/** @format */

const config = {
    admin: require('../admin.dev.json'),
};

export default config;
